import React from "react";
import { useI18n } from "bananas-commerce-admin";

import { Clear } from "@mui/icons-material";
import { Button, ButtonProps, useTheme } from "@mui/material";

const RemoveButton: React.FC<ButtonProps> = (props) => {
  const { t } = useI18n();
  const theme = useTheme();

  return (
    <Button
      {...props}
      endIcon={<Clear />}
      size="small"
      sx={{
        color: theme.palette.grey[600], // TODO Fix dark mode
        textTransform: "none",
        whiteSpace: "nowrap",
        ...props.sx,
      }}
      variant="text"
    >
      {t("Ta bort")}
    </Button>
  );
};

export default RemoveButton;
